import CustomButton from '../../../common/components/CustomButton';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomTextInput from '../../../common/components/CustomTextInput';
import Tooltip from '../../../common/components/Tooltip';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type CopyrightTransferTypeSelectFormViewFieldName = 'copyright_transfer_type'|'lyric_writer_name_kana'|'composer_name_kana';

export default function CopyrightTransferTypeSelectFormView({
  karaokeOrder,
  getValue,
  setValue,
  getErrors,
  onNext,
} : {
  getValue: (name: CopyrightTransferTypeSelectFormViewFieldName) => string,
  setValue: (name: CopyrightTransferTypeSelectFormViewFieldName, value: string) => void,
  getErrors: (name: CopyrightTransferTypeSelectFormViewFieldName) => FieldValidationErrorsType,
  karaokeOrder: {
    title: string,
    lyric_writer_name: string,
    composer_name: string,
    applicant_name: string,
  },
  onNext: () => void,
}) {
  const copyrightTransferTypeOptions = [
    { value: '0', title: '私自身が1人で作詞作曲しました。', description: 'シンガーソングライターなど' },
    { value: '1', title: '私以外が作詞や作曲に関わりました。', description: 'グループ名義での作曲などもこちら' },
    { value: '2', title: '私以外が作詞や作曲に関わりましたが、すでに著作権は全て私に譲渡されています。' },
  ];

  return (
    <>
      <h2>
        印税を受け取るための
        <br />
        著作権手続きについて
      </h2>
      <p className="mb50">
        手続き後、この曲がカラオケで歌われたり、テレビやラジオで流れるとあなたに印税が発生します。
        <br />
      </p>
      <h3>
        あなたが印税を
        <br />
        受け取るためのしくみ
      </h3>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright.png" alt="著作権の手続き" />
        </div>
      </div>
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body copyright_layout">
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label>
                  「
                  {karaokeOrder.title}
                  」
                  <br />
                  申込者名(本名)
                  <Tooltip message='必ず本名でお手続きください。ログイン後のメニュー「カラオケ配信の管理」にて"申込者名"の修正依頼が可能です。' />
                  ：
                  {karaokeOrder.applicant_name}
                  <br />
                  作詞：
                  {karaokeOrder.lyric_writer_name}
                  <br />
                  <li className="col span_24" style={{ marginBottom: '10px' }}>
                    <span className="col span_8">
                      作詞者名（ひらがな）：
                    </span>
                    <span className="col span_16">
                      <CustomTextInput
                        placeholder="さくし たろう"
                        value={getValue('lyric_writer_name_kana')}
                        setValue={(value) => setValue('lyric_writer_name_kana', value)}
                        validationErrors={getErrors('lyric_writer_name_kana')}
                      />
                    </span>
                  </li>
                  <br />
                  作曲：
                  {karaokeOrder.composer_name}
                  <br />
                  <li className="col span_24" style={{ marginBottom: '10px' }}>
                    <span className="col span_8">
                      作曲者名（ひらがな）：
                    </span>
                    <span className="col span_16">
                      <CustomTextInput
                        placeholder="さっきょく たろう"
                        value={getValue('composer_name_kana')}
                        setValue={(value) => setValue('composer_name_kana', value)}
                        validationErrors={getErrors('composer_name_kana')}
                      />
                    </span>
                  </li>
                  <br />
                  <br />
                  の、作詞者・作曲者について当てはまるものを選択してください。
                  <br />
                  <br />
                </label>
              </dt>
              <dd className="select">
                <CustomRadio
                  value={getValue('copyright_transfer_type')}
                  setValue={(value) => setValue('copyright_transfer_type', value)}
                  options={copyrightTransferTypeOptions}
                  validationErrors={getErrors('copyright_transfer_type')}
                />
              </dd>
            </dl>
            <p className="repletion">
              著作権の手続きについて、分からないことがある場合は
              <br />
              <a href="https://help.frekul.com/artist/karaoke/" target="_blank" rel="noreferrer">こちら</a>
              をお読みください。
            </p>
            <ul>
              <li className="bt">
                <CustomButton type="default" onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}

